import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";

import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";

import {
    NumberYearsVibratingToolsOptions,
    MonthsUsingVibratingToolsLastYearOptions,
    HoursPerWeekUsingVibratingToolsOptions,
    SeasonUsingVibratingToolsMostOptions,
    LeftRightHandOptions,
    FingersGoNumbWhenOptions,
    DifficultyWithFineMovementsSymptomsOptions
} from "../questions/section10Questions";
import * as questionIds from "../questions/questionIds";
import { HealthSurveillanceSectionProps } from "../models";
import { sections } from "../questionnaire";

// eslint-disable-next-line max-len
const HealthSurveillanceHavsSectionUnconnected: React.FunctionComponent<HealthSurveillanceSectionProps> = (props: HealthSurveillanceSectionProps) => {
    return (
        <OldProgressBarQuestionnaireSectionUnconnected
            {...props}
            {...sections.HAVS}
        >
            <h4>Work Details</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.UseVibratingTools),
                    getQuestionConfig(props.questionConfigs, questionIds.UseVibratingToolsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.VibratingToolsLast12Months),
                    getQuestionConfig(props.questionConfigs, questionIds.VibratingToolsLast12MonthsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.YearsUsingVibratingTools)}
                options={NumberYearsVibratingToolsOptions}
                readonly={props.readonly}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.MonthsUsingVibratingToolsLastYear)}
                options={MonthsUsingVibratingToolsLastYearOptions}
                readonly={props.readonly}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HoursPerWeekUsingVibratingTools)}
                options={HoursPerWeekUsingVibratingToolsOptions}
                readonly={props.readonly}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.SeasonUsingVibratingToolsMost)}
                options={SeasonUsingVibratingToolsMostOptions}
                readonly={props.readonly}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhichHandFeelsMostVibration)}
                options={LeftRightHandOptions}
                readonly={props.readonly}
            />
            <DropdownQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.LeftRightHanded)}
                options={LeftRightHandOptions}
                readonly={props.readonly}
            />
            <h4>Medical History</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.ProblemsWithHandsOrArms),
                    getQuestionConfig(props.questionConfigs, questionIds.ProblemsWithHandsOrArmsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.EverNeckArmHandInjury),
                    getQuestionConfig(props.questionConfigs, questionIds.EverNeckArmHandInjuryFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.SeriousDiseaseJointsNervesHeatBloodVessels),
                    getQuestionConfig(props.questionConfigs, questionIds.SeriousDiseaseJointsNervesHeatBloodVesselsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HavsReceivingTreatment),
                    getQuestionConfig(props.questionConfigs, questionIds.HavsReceivingTreatmentFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HavsDoYouSmoke),
                    getQuestionConfig(props.questionConfigs, questionIds.HavsDoYouSmokeFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HavsEverSmoked),
                    getQuestionConfig(props.questionConfigs, questionIds.HavsEverSmokedWhenStopped)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HavsDrinkAlcohol),
                    getQuestionConfig(props.questionConfigs, questionIds.HavsDrinkAlcoholNumberUnitsPerWeek)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Social History</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HobbiesExposeToVibrations),
                    getQuestionConfig(props.questionConfigs, questionIds.HobbiesExposeToVibrationsFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Family History</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.FamilyVibrationWhiteFinger),
                    getQuestionConfig(props.questionConfigs, questionIds.FamilyVibrationWhiteFingerWho)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            <h4>Symptoms</h4>
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoneWhiteInCold)}
                readonly={props.readonly}
            />
            {getAnswerToQuestionWithId(values(props.questions || {}), questionIds.FingersGoneWhiteInCold) === MultiButtonQuestion.YesOption &&
            <>
                <MultiButtonQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoneWhiteInColdLastYear)}
                    readonly={props.readonly}
                />
                <MultiButtonQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DifficultyWarmingFingers)}
                    readonly={props.readonly}
                />
                <DropdownQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ContinuousDifficultyWarmingFingers)}
                    readonly={props.readonly}
                    options={[
                        { text: "Continuous", value: "Continuous" },
                        { text: "Some of the time", value: "SomeOfTheTime" }
                    ]}
                />
                <DropdownQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.WhenDifficultyWarmingFingers)}
                    readonly={props.readonly}
                    options={[
                        { text: "Only in cold weather", value: "OnlyColdWeather" },
                        { text: "All year round", value: "AllYearRound" },
                        { text: "Several times a month", value: "SeveralTimesAMonth" },
                        { text: "Every day", value: "EveryDay" },
                        { text: "Several times during the day", value: "SeveralTimesDuringDay" }
                    ]}
                />
                <TextQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoneWhiteInColdFurtherDetails)}
                    readonly={props.readonly}
                />
            </>}
            <h4>Tingling</h4>
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.TinglingFingers),
                    getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {props.questions[questionIds.TinglingFingers]?.answer === MultiButtonQuestion.YesOption && <>
                {YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersWhilstWorking),
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersWhilstWorkingFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersInResponseToCold),
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersInResponseToColdFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersOccurOtherTimes),
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersOccurOtherTimesFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
                {YesNoWithFollowUpQuestion({
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersAtNight),
                        getQuestionConfig(props.questionConfigs, questionIds.TinglingFingersAtNightFurtherDetails)
                    ],
                    readonly: props.readonly,
                    questions: props.questions
                })}
            </>}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.TinglingForearm),
                    getQuestionConfig(props.questionConfigs, questionIds.TinglingForearmFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {YesNoWithFollowUpQuestion({
                questionConfigs: [
                    getQuestionConfig(props.questionConfigs, questionIds.HistoryOfBalanceCondition),
                    getQuestionConfig(props.questionConfigs, questionIds.HistoryOfBalanceConditionFurtherDetails)
                ],
                readonly: props.readonly,
                questions: props.questions
            })}
            {(props.questions[questionIds.TinglingFingers]?.answer === MultiButtonQuestion.YesOption ||
                props.questions[questionIds.TinglingForearm]?.answer === MultiButtonQuestion.YesOption) &&
                <TextQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.HowLongHadTingling)} readonly={props.readonly} />
            }
            <h4>Numbness</h4>
            <MultiButtonQuestion questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoNumb)} readonly={props.readonly} />
            {getAnswerToQuestionWithId(values(props.questions || {}), questionIds.FingersGoNumb) === MultiButtonQuestion.YesOption &&
            <>
                <DropdownQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoNumbWhen)}
                    readonly={props.readonly}
                    options={FingersGoNumbWhenOptions}
                />
                <TextQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.FingersGoNumbFirstNoticed)}
                    readonly={props.readonly}
                />
            </>}
            <h4>Dexterity</h4>
            <MultiButtonQuestion
                questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DifficultyWithFineMovements)}
                readonly={props.readonly}
            />
            {getAnswerToQuestionWithId(values(props.questions || {}), questionIds.DifficultyWithFineMovements) === MultiButtonQuestion.YesOption &&
            <>
                <DropdownQuestion
                    multiple
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DifficultyWithFineMovementsLeftHandSymptoms)}
                    readonly={props.readonly}
                    options={DifficultyWithFineMovementsSymptomsOptions}
                />
                <DropdownQuestion
                    multiple
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.DifficultyWithFineMovementsRightHandSymptoms)}
                    readonly={props.readonly}
                    options={DifficultyWithFineMovementsSymptomsOptions}
                />
                <MultiButtonQuestion
                    questionConfig={getQuestionConfig(props.questionConfigs, questionIds.ReportedDifficultyWithFineMovementSymptoms)}
                    readonly={props.readonly}
                />
            </>}
        </OldProgressBarQuestionnaireSectionUnconnected>
    );
};

// eslint-disable-next-line max-len
export const HealthSurveillanceHavsSection = connect(makeMapStateToQuestionnaireSectionProps(sections.HAVS.id), mapDispatchToQuestionnaireSectionProps)(HealthSurveillanceHavsSectionUnconnected);
